module.exports = __webpack_public_path__ + "media/images/static/top/urban/right_photo_mobile-1c37fc79a32f6993831ed64d0a7af1ac.png";